import React from 'react';
import BaseSimplePage from "../BaseSimplePage/BaseSimplePage";
import EventTypesItemForm from "./EventTypesItemForm";

const EventTypesPage = ({isAddSubMode}) => {

    return (
        <BaseSimplePage
            isAddSubMode={isAddSubMode}
            modeApiName1="type"
            modeApiName2="types"
            ItemFormComponent={EventTypesItemForm}
        />
    );
};

export default EventTypesPage;